import axios from "axios";

// CRA environment variable
const BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

if (!BASE_URL) {
  console.error("REACT_APP_BACKEND_API_URL is not defined in .env");
}

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 5000,
});

// Optional: Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default api;
